import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { COLOR, colors } from 'reporting-ui-components/constants/colors';
import Categories from 'ContentUtils/constants/Categories';
import * as ContentUtilsRequestStatus from 'ContentUtils/constants/RequestStatus';
import { CommentObjectType } from 'collaboration-sidebar';
export const RequestStatus = ContentUtilsRequestStatus;
export const ContentTypes = {
  BLOG_LISTING_PAGE: 'BLOG_LISTING_PAGE',
  BLOG_POST: 'BLOG_POST',
  EXTERNAL_PAGE: 'EXTERNAL_PAGE',
  LANDING_PAGE: 'LANDING_PAGE',
  SITE_PAGE: 'SITE_PAGE'
};
export const MultiLanguageContentTypeScopes = {
  [ContentTypes.BLOG_POST]: 'blog-multilanguage',
  [ContentTypes.LANDING_PAGE]: 'landingpages-multilanguage',
  [ContentTypes.SITE_PAGE]: 'sitepages-multilanguage'
};
export const ContentSlugToContentType = {
  [Categories['blog-post'].slug_singular]: ContentTypes.BLOG_POST,
  [Categories['landing-page'].slug_singular]: ContentTypes.LANDING_PAGE,
  [Categories['site-page'].slug_singular]: ContentTypes.SITE_PAGE,
  [Categories['blog-listing-page'].slug_singular]: ContentTypes.BLOG_LISTING_PAGE,
  'external-page': ContentTypes.EXTERNAL_PAGE
};
export const ContentTypeToContentSlug = {
  [ContentTypes.BLOG_POST]: Categories['blog-post'].slug_singular,
  [ContentTypes.LANDING_PAGE]: Categories['landing-page'].slug_singular,
  [ContentTypes.SITE_PAGE]: Categories['site-page'].slug_singular,
  [ContentTypes.BLOG_LISTING_PAGE]: Categories['site-page'].slug_singular,
  [ContentTypes.EXTERNAL_PAGE]: 'external-page'
};
export const ContentTypeToContentId = {
  [ContentTypes.BLOG_POST]: Categories['blog-post'].id,
  [ContentTypes.EXTERNAL_PAGE]: Categories['landing-page'].id,
  [ContentTypes.LANDING_PAGE]: Categories['landing-page'].id,
  [ContentTypes.SITE_PAGE]: Categories['site-page'].id,
  [ContentTypes.BLOG_LISTING_PAGE]: Categories['blog-listing-page'].id
};
export const ContentTypesToSocialShareTypes = {
  [ContentTypes.LANDING_PAGE]: Categories['landing-page'].slug_singular,
  [ContentTypes.SITE_PAGE]: Categories['site-page'].slug_singular,
  [ContentTypes.BLOG_POST]: Categories['blog-post'].slug_singular
};
export const PATHS = {
  OPTIMIZATION: 'optimization',
  PERFORMANCE: 'performance',
  PUBLISHED: 'published',
  SCHEDULED: 'scheduled',
  SMART_CONTENT: 'smart-content',
  TEST_RESULTS: 'testResults'
};
export const GATES = {
  ACCESS_CONTROL_LIBRARY: 'ContentMembership:SitePageLandingPageAccessLibrary',
  ACCESS_GROUPS: 'ContentMembership:AccessGroups',
  BLOG_DATA_WALL: 'ContentMembership:BlogDataWall',
  FOLLOW_UP_REGISTRATION_EMAILS: 'settings-ui-cms:follow-up-emails',
  PATAGONIA_REDESIGN: 'ContentEditorUI:PatagoniaRedesign',
  PUBLISH_PRIVATE_CONTENT: 'UserManagement:PublishPrivateContent'
};
export const PageState = {
  APPROVED: 'APPROVED',
  ARCHIVED: 'ARCHIVED',
  AUTOMATED: 'AUTOMATED',
  AUTOMATED_DRAFT: 'AUTOMATED_DRAFT',
  AUTOMATED_FOR_FORM: 'AUTOMATED_FOR_FORM',
  AUTOMATED_FOR_FORM_DRAFT: 'AUTOMATED_FOR_FORM_DRAFT',
  AUTOMATED_LEADFLOW_EMAIL: 'AUTOMATED_LEADFLOW_EMAIL',
  BLOG_EMAIL_DRAFT: 'BLOG_EMAIL_DRAFT',
  BLOG_EMAIL_PUBLISHED: 'BLOG_EMAIL_PUBLISHED',
  DRAFT: 'DRAFT',
  DRAFT_AB: 'DRAFT_AB',
  DRAFT_AB_VARIANT: 'DRAFT_AB_VARIANT',
  ERROR: 'ERROR',
  LOSER_AB_VARIANT: 'LOSER_AB_VARIANT',
  PAGE_STUB: 'PAGE_STUB',
  PENDING_AKISMET: 'PENDING_AKISMET',
  PENDING_MODERATION: 'PENDING_MODERATION',
  PRE_PROCESSING: 'PRE_PROCESSING',
  PROCESSING: 'PROCESSING',
  PUBLISHED: 'PUBLISHED',
  PUBLISHED_AB: 'PUBLISHED_AB',
  PUBLISHED_AB_VARIANT: 'PUBLISHED_AB_VARIANT',
  PUBLISHED_OR_SCHEDULED: 'PUBLISHED_OR_SCHEDULED',
  REJECTED: 'REJECTED',
  RSS_TO_EMAIL_DRAFT: 'RSS_TO_EMAIL_DRAFT',
  RSS_TO_EMAIL_PUBLISHED: 'RSS_TO_EMAIL_PUBLISHED',
  SCHEDULED: 'SCHEDULED',
  SCHEDULED_AB: 'SCHEDULED_AB',
  SPAM: 'SPAM'
};
export const SCHEDULED_STATES = ImmutableSet.of(PageState.SCHEDULED, PageState.SCHEDULED_AB, PageState.PUBLISHED_OR_SCHEDULED);
export const REQUEST_STATUS_PROPS = Object.keys(RequestStatus);
export const NON_DEPLOYED_STATES = ImmutableSet.of(PageState.DRAFT, PageState.DRAFT_AB, PageState.DRAFT_AB_VARIANT, PageState.LOSER_AB_VARIANT, PageState.SCHEDULED, PageState.SCHEDULED_AB, PageState.PAGE_STUB);
export const LayoutLinkTypes = {
  LAYOUT: 'Layout',
  TEMPLATE: 'Template File'
};
export const PUBLISHED_STATES = ImmutableSet.of(PageState.PUBLISHED, PageState.PUBLISHED_AB, PageState.PUBLISHED_AB_VARIANT, PageState.AUTOMATED, PageState.AUTOMATED_FOR_FORM, PageState.APPROVED, PageState.BLOG_EMAIL_PUBLISHED, PageState.RSS_TO_EMAIL_PUBLISHED, PageState.AUTOMATED_LEADFLOW_EMAIL, PageState.PUBLISHED_OR_SCHEDULED);
export const DRAFT_STATES = ImmutableSet.of(PageState.DRAFT, PageState.DRAFT_AB, PageState.DRAFT_AB_VARIANT, PageState.AUTOMATED_DRAFT, PageState.AUTOMATED_FOR_FORM_DRAFT, PageState.ARCHIVED, PageState.PENDING_AKISMET, PageState.PENDING_MODERATION, PageState.BLOG_EMAIL_DRAFT, PageState.RSS_TO_EMAIL_DRAFT);
export const ERROR_STATES = ImmutableSet.of(PageState.ERROR, PageState.SPAM, PageState.REJECTED);
export const THUNDERDOME_STATES = ImmutableSet.of(PageState.PROCESSING, PageState.PRE_PROCESSING);
export const FETCH_LISTS_DEBOUNCE_MS = 500;
export const VARIANT_STATES = ImmutableSet.of(PageState.PUBLISHED_AB_VARIANT, PageState.DRAFT_AB_VARIANT, PageState.LOSER_AB_VARIANT);
export const VARIANT_TYPES = ImmutableMap({
  LOSER: 'loser_variant',
  MASTER: 'master',
  VARIANT: 'variant'
});
export const ContentTypeToConvertedContentType = {
  [ContentTypes.BLOG_POST]: ContentTypes.BLOG_POST,
  [ContentTypes.EXTERNAL_PAGE]: ContentTypes.EXTERNAL_PAGE,
  [ContentTypes.LANDING_PAGE]: ContentTypes.SITE_PAGE,
  [ContentTypes.SITE_PAGE]: ContentTypes.LANDING_PAGE,
  [ContentTypes.BLOG_LISTING_PAGE]: ContentTypes.BLOG_LISTING_PAGE
};
export const ContentTypeToSubcategory = {
  [ContentTypes.LANDING_PAGE]: Categories['landing-page'].field_name,
  [ContentTypes.SITE_PAGE]: Categories['site-page'].field_name
};
export const ContentTypeToCommentObjectType = {
  [ContentTypes.LANDING_PAGE]: CommentObjectType.LANDING_PAGE,
  [ContentTypes.SITE_PAGE]: CommentObjectType.WEBSITE_PAGE,
  [ContentTypes.BLOG_POST]: CommentObjectType.BLOG_POST,
  [ContentTypes.BLOG_LISTING_PAGE]: CommentObjectType.BLOG_LISTING_PAGE
};
export const ContentTypesSupportedByRestrictionsLib = [ContentTypes.LANDING_PAGE, ContentTypes.SITE_PAGE, ContentTypes.BLOG_POST];
export const PATHS_PROPS = Object.values(PATHS);
export const CONTENT_TYPE_PROPS = Object.keys(ContentTypes);
export const MAB_ENABLED_CONTENT_TYPES = [ContentTypes.LANDING_PAGE, ContentTypes.SITE_PAGE];
export const PENDING_STATUSES = ImmutableSet.of(RequestStatus.PENDING, RequestStatus.UNINITIALIZED);
export const ALL_VARIATIONS = 'all';
export const SIZE_OF_EMPTY_MAB_STATE_ILLUSTRATION = 200;
export const MAB_VARIATION_COLORS = [colors.get(COLOR.ORANGE), colors.get(COLOR.PURPLE), colors.get(COLOR.YELLOW), colors.get(COLOR.PINK), colors.get(COLOR.AQUA)];
export const ContentSecurityStates = {
  CLEAR: 'CLEAR',
  FLAGGED_FOR_REVIEW: 'FLAGGED_FOR_REVIEW',
  NONE: 'NONE',
  SECURITY_VIOLATION: 'SECURITY_VIOLATION'
};
export const VIOLATION_STATES = [ContentSecurityStates.FLAGGED_FOR_REVIEW, ContentSecurityStates.SECURITY_VIOLATION];
export const CRM_PAGE_OBJECT_TYPE = '0-10';
export const HUBSPOT_VIDEO_CRM_OBJECT_TYPE = '0-57';
export const LANDING_PAGES_TRUSTED_SCOPE = 'landingpages-trusted';
export const ACCOUNT_VERIFICATION_SOURCE = 'LANDING_PAGES';